/**
 * Token counts for display: 10000000 → "10M", 1322695 → "1.32M",
 * 100000 → "100K", 950 → "950". Compact is for reading at a glance; show
 * formatTokensExact() alongside (tooltip/caption) wherever the figure is billed,
 * so nothing is hidden by rounding.
 */
const UNITS: Array<{ value: number; suffix: string }> = [
  { value: 1e9, suffix: 'B' },
  { value: 1e6, suffix: 'M' },
  { value: 1e3, suffix: 'K' },
];

function round(x: number): number {
  const dp = x >= 100 ? 0 : x >= 10 ? 1 : 2;
  return parseFloat(x.toFixed(dp));
}

export function formatTokensCompact(n: number | null | undefined): string {
  const v = Number(n);
  if (!Number.isFinite(v)) return '0';
  const abs = Math.abs(v);
  for (let i = UNITS.length - 1; i >= 0; i--) {
    const unit = UNITS[i]!;
    const next = UNITS[i - 1];
    if (next && abs >= next.value) continue;
    if (abs < unit.value) continue;
    const r = round(abs / unit.value);
    // 999,999 must read "1M", not "1000K".
    if (r >= 1000 && next) return `${v < 0 ? '-' : ''}${round(abs / next.value)}${next.suffix}`;
    return `${v < 0 ? '-' : ''}${r}${unit.suffix}`;
  }
  return String(Math.round(v));
}

export function formatTokensExact(n: number | null | undefined): string {
  return `${Math.round(Number(n) || 0).toLocaleString()} tokens`;
}
